import backofficeService from '../../api/backoffice'


export default {

  /**
   * Get list of products
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to products
   */
  async getAll(params) {
    return backofficeService.Api().get('product', { params })
      .then(response => {
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },

  bulkAdjustStock(payload) {
    return backofficeService
      .Api()
      .post("product/bulk-adjust", payload)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },

  getProductHistory(id, params = {}) {
    return backofficeService.Api().get(`product/${id}/history`, {
      params
    })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  thumbnailStatus(params = {}) {
    return backofficeService
      .Api()
      .get("image/status", { params })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },

  processThumbnails(limit = 25) {
    return backofficeService
      .Api()
      .post("image/process", { limit })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },

  async fix(params) {
    return backofficeService.Api().get('image/fix', { params })
      .then(response => {
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },


  async minimumReached(params) {
    return backofficeService.Api().get('product/minimumReached', { params })
      .then(response => {
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },

  async upcSearch(params) {
    return backofficeService.Api().get('product/upcSearch', { params })
      .then(response => {
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },

  async getAllCaregoryProduct(params) {
    return backofficeService.Api().get('product', { params })
      .then(response => {
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },
  /**
   * Get specific product
   * @param {*} id
   * @param {*} params
   * @param {*} params.local Add LocalData to product
   */
  getById(id, params = {}) {
    return backofficeService.Api().get(`product/${id}`, {
      params
    })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  merge(data) {
    return backofficeService.Api().post('product/merge', data)
      .then(response => {
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },


  getAvgCost(id, params = {}) {
    return backofficeService.Api().get(`product/avgCost/${id}`, {
      params
    })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  updateBalance(id, params = {}) {
    return backofficeService.Api().get(`product/updateBalance/${id}`, {
      params
    })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  getSyncInfo(id, params = {}) {
    return backofficeService.Api().get(`product/syncInfoById/${id}`, {
      params
    })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  getPriceRange(params) {
    return backofficeService.Api().get('product/range', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  getHistory(id, params = {}) {
    return backofficeService.Api().get(`product/history/${id}`, {
      params
    })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  async noInvoice(params) {
    return backofficeService.Api().get('report/noInvoice/product', {
      params
    })
      .then(response => {
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },

  searchProductImages(params = {}) {
    return backofficeService.Api().get('product/images/search', { params })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  importProductImage(data) {
    return backofficeService.Api().post('product/images/import', data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  // Compatibility for older one-click image actions. The result is imported
  // into our owned media library before it is returned to the product.
  async getGooglePic(params = {}) {
    const searchResponse = await this.searchProductImages({ q: params.name || params.q })
    const searchResult = searchResponse && searchResponse.data
      ? searchResponse.data
      : searchResponse
    const candidate = searchResult && searchResult.candidates
      ? searchResult.candidates[0]
      : null

    if (!candidate) return { data: null }

    const importResponse = await this.importProductImage({
      identity: { name: params.name || params.q },
      sourceUrl: candidate.url,
      sourcePage: candidate.sourcePage || null,
      visibility: 'shared_pending'
    })
    const imported = importResponse && importResponse.data
      ? importResponse.data
      : importResponse

    return {
      data: imported && imported.imageUrl
        ? { imgUrl1: imported.imageUrl, source: searchResult.source }
        : null
    }
  },

  /**
   * Create a product. Will also initiate location data
   * @param {*} data
   */
  create(data) {
    return backofficeService.Api().post('product', data)
      .then(response => {
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },
  /**
   * Update specific product
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`product/${id}`, data)
      .then(response => {
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },
  /**
   * Delete product
   * @param {} id
   * @param {*} params
   */
  delete(id, params) {
    return backofficeService.Api().delete(`product/${id}`, {
      params
    })
      .then(response => {
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },

  stockAdjustment: {
    create(data) {
      return backofficeService.Api().post('stockAdjustment', data)
        .then(response => {
          return response.data
        })
        .catch((error) => {
          throw error
        })
    },
  }

}
